import React, { Fragment, useState, useEffect } from "react";
import "./manage-question.styles.scss";
import TabLayout from "../tab-layout/tab-layout.component";
import InsertQuestionPage from "../../pages/staff/quiz-page/insert-question-page/insert-question-page.component";
import ViewQuestionsPage from "../../pages/staff/quiz-page/view-question-page/view-question-page.component";
import { GlobalState } from "../../redux/root-reducer";
import { connect } from "react-redux";
import { fetchApi } from "../../redux/fetch/fetch.actions";
import { IFetchQuestionsPayload } from "../../redux/question/question.actions";
import { Dispatch } from "redux";
import { Question } from "../../@types/question.interface";

interface IProps {
    quizId: number;
    userEmail: string;
    questions: Question[] | null;
    fetchQuestions: (id: number) => void;
}

function ManageQuestionContainer({
    quizId,
    userEmail,
    questions,
    fetchQuestions,
}: IProps) {
    const [activeTab, setActiveTab] = useState<number>(0);
    const tabNames = ["View Questions", "Insert Question"];
    const Components = [
        <ViewQuestionsPage
            setActiveTab={setActiveTab}
            quizId={quizId}
            userEmail={userEmail}
        />,
        <InsertQuestionPage
            setActiveTab={setActiveTab}
            questionNumber={questions ? questions.length + 1 : 1}
        />,
    ];
    const Component = Components[activeTab];

    useEffect(() => {
        return () => {
            setActiveTab(0);
        };
    }, [setActiveTab]);

    useEffect(() => {
        if (questions === null) fetchQuestions(quizId);
    }, [questions, fetchQuestions, quizId]);

    return (
        <div className="manage-question">
            <div className="title">
                <h2 className="heading">Manage Question</h2>
            </div>
            <div className="manage-question__detail">
                <Fragment>
                    <TabLayout
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        tabs={tabNames}
                    />
                    {Component}
                </Fragment>
            </div>
        </div>
    );
}

const mapStateToProps = ({
    fetchController: { isFetching, errors },
    question: { questions },
}: GlobalState) => ({
    isFetching: isFetching.QUESTIONS,
    errors: errors.QUESTIONS,
    questions,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchQuestions: (id: IFetchQuestionsPayload["data"]["id"]) =>
        dispatch(fetchApi({ name: "QUESTIONS", data: { id } })),
});

const ManageQuestion = connect(
    mapStateToProps,
    mapDispatchToProps
)(ManageQuestionContainer);

export default ManageQuestion;
